<template>
    <div class="avatar-upload">
        <div class="form-group">
            <div class="custom-file">
                <label for="avatar">
                    <span v-if="processing"><spinner :color="'#750175'" class="m-0 p-0"></spinner></span>
                    <span v-else-if="hasAvatar"><i class="fas fa-user-edit"></i></span>
                    <span v-else><i class="fas fa-pencil-ruler"></i></span>
                </label>
                <input type="file" class="d-none custom-file-input" id="avatar" accept="image/*" @change="submit">
            </div>
        </div>
        <!--
        <button type="button" class="btn btn-link-grey btn-sm btn-no-padding" @click="deleteAvatar" v-if="hasAvatar">
            Of verwijderen
        </button>
        -->
    </div>
</template>

<script>
    import Spinner from 'vue-spinner-component/src/Spinner'

    export default {
        components: {
            Spinner
        },
        props: {
            hasAvatarProp: Boolean,
        },
        data() {
            return {
                hasAvatar: this.hasAvatarProp,
                processing: false,
            }
        },
        methods: {
            submit(e) {
                this.processing = true;

                let data = new FormData();

                let that = this;
                let files = e.target.files || e.dataTransfer.files;
                data.append('avatar', files[0]);

                this.axios.post('/profile/avatar', data).then(res => {
                    that.setAvatar(res.data.src);
                    that.hasAvatar = true;
                }).catch(() => {
                    this.$notify({
                        group: 'base',
                        text: 'Het uploaden is mislukt.',
                        type: 'alert-danger',
                    });
                }).finally(() => {
                    this.processing = false
                })
            },
            deleteAvatar() {
                let that = this;

                this.axios.delete('/profile/avatar').then(res => {
                    that.setAvatar(res.data.src);
                    that.hasAvatar = false;
                }).catch(() => {
                    this.$notify({
                        group: 'base',
                        text: 'Het verwijderen is mislukt.',
                        type: 'alert-danger',
                    });
                })
            },
            setAvatar(src) {
                document.querySelectorAll('.avatar img').forEach(function (img) {
                    img.src = src;
                });
            },
        }
    }
</script>